import type { FC } from 'react'
import LazyLoad from 'react-lazyload'
import AboutUsSection from '~/components/AboutUs/AboutUsSection'
import CorePhilosophySection from '~/components/AboutUs/CorePhilosophySection'
import DesignedForGrowthSection from '~/components/AboutUs/DesignedForGrowthSection'
import MessageUsSection from '~/components/AboutUs/MessageUsSection'
import OurLeadershipSection from '~/components/AboutUs/OurLeadershipSection'
import OurStorySection from '~/components/AboutUs/OurStorySection'
import JourneySection from '~/components/LandingPage/JourneySection'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'

const LazyLoadWrapper = LazyLoad as unknown as FC<any>

const AboutUsContainer = () => {
  return (
    <LayoutLandingPage>
      <AboutUsSection />

      <LazyLoadWrapper height={300} once>
        <MessageUsSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <CorePhilosophySection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <DesignedForGrowthSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <OurStorySection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <OurLeadershipSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <JourneySection className="desktop:mt-[140px] desktop:mb-[0px] bg-gray-50 mt-[64px] my-[0px] py-[64px]" />
      </LazyLoadWrapper>
    </LayoutLandingPage>
  )
}

export default AboutUsContainer
